import { ca } from '@cian/analytics';

/* istanbul ignore next */
export function trackDeveloperFlatsLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_developersFlats',
    label: 'all',
    useLastProducts: true,
  });
}

/* istanbul ignore next */
export function trackOffersToLayoutsSwitcherClick({ isActive }: { isActive: boolean }) {
  const action = isActive ? 'turn_on_sopr' : 'turn_off_sopr';
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action,
    label: 'jk_layouts',
    useLastProducts: true,
  });
}
